import React from "react";
import OnboardingScreen, { OnboardingTitle } from "../OnboardingScreen";
import { OnboardingGlassButton, OnboardingNextButton } from "../OnboardingButtons";
import PeakTextField from "../PeakTextField";

interface GoalStepProps {
  value: string;
  progress: number | null;
  canContinue: boolean;
  onChange: (value: string) => void;
  onBack: () => void;
  onContinue: () => void;
  onSkip: () => void;
}

const GoalStep: React.FC<GoalStepProps> = ({ value, progress, canContinue, onChange, onBack, onContinue, onSkip }) => (
  <OnboardingScreen
    progress={progress}
    onBack={onBack}
    footer={
      <div className="flex flex-col gap-3">
        <OnboardingNextButton label="Set my goal" enabled={canContinue} onClick={onContinue} />
        <OnboardingGlassButton label="I don't have a goal, skip." onClick={onSkip} />
      </div>
    }
  >
    <div className="flex flex-col gap-7">
      <OnboardingTitle title="What's your goal?" subtitle="What are you working towards?" />
      <PeakTextField label="Your goal" value={value} onChange={onChange} placeholder="Break 40 in the 10k" multiline minHeight={96} />
    </div>
  </OnboardingScreen>
);

export default GoalStep;
